import React from 'react';
import KinsThreadLoadingScreen from './KinsThreadLoadingScreen';

const LoadingPage = ({ 
  message = "Loading your heritage journey..."
}) => {
  return <KinsThreadLoadingScreen message={message} />;
};

export default LoadingPage;